<script setup lang="ts">
import CategorySwipeTrack from './CategorySwipeTrack.vue';
import Category from '../../store/classes/Category';
import {computed, ref} from 'vue';
import {TEXT_BLOCK_TEXT_ID} from '../../scripts/constants';
import {useTextBlocks} from '../../../../admin/src/compositions';
import {TextBlock} from '../../types';


defineProps<{
    categories: Category[],
    activeCategory: number,
}>();

const emit = defineEmits<{
    (event: 'toggle-search'): void,
    (event: 'select-category', id: number): void,
}>();

const isBannerClamped = ref(true);
const expandNotice = ref(false);

const bannerButtonText = computed(() => expandNotice.value ? 'Read Less' : 'Read More');
const { textBlocks } = useTextBlocks();
const textBlockList = ref<TextBlock[]>(Object.values(textBlocks.value));
const bannerEnabled = ref<number>(textBlockList.value.find(block => block.textId === TEXT_BLOCK_TEXT_ID.BANNER)?.textDetails.status ?? 0);
const bannerText = computed<string>({
    get() {
        return textBlockList.value.find(block => block.textId === TEXT_BLOCK_TEXT_ID.BANNER)?.textDetails.content ?? '';
    },
    set(value) {
        const bannerTextBlock = textBlockList.value.find(block => block.textId === TEXT_BLOCK_TEXT_ID.BANNER);
        if (bannerTextBlock) {
            bannerTextBlock.textDetails.content = value;
            return;
        }

        textBlockList.value.push({
            id: 0,
            businessId: 0,
            merchantId: 0,
            dateCreated: '0000-00-00 00:00:00',
            dateUpdated: '0000-00-00 00:00:00',
            textId: TEXT_BLOCK_TEXT_ID.BANNER,
            textDetails: {
                title: 'Banner',
                status: 1,
                content: value,
            },
        });
    },
});

const isTextClamped = (entry: ResizeObserverEntry[]) => {
    const element = entry[0].target;
    isBannerClamped.value = element.scrollHeight > element.clientHeight;
};
</script>

<template>
    <div id="sticky-header" class="quick-order-view__header">
        <div class="quick-order-view__header__banner-message">
            <div v-if="bannerEnabled && bannerText" class="flex-grow-1 banner-notice p-16 text-white tr12 text-break">
                <p>
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <span
                        :class="{ expand: expandNotice }"
                        class="banner-notice__text"
                        v-resize="isTextClamped"
                        v-html="bannerText"/>
                    <span
                        v-if="isBannerClamped || expandNotice"
                        class="banner-notice__btn text-bold"
                        @click="expandNotice = !expandNotice"
                        v-text="bannerButtonText"/>
                </p>
            </div>
        </div>
        <div class="quick-order-view__header__category-bar">
            <CategorySwipeTrack
                :categories="categories"
                :activeCategory="activeCategory"
                @select-category="(id) => emit('select-category', id)"
                @toggle-search="emit('toggle-search')"/>
        </div>
    </div>
</template>
